var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.params.text)?_c('BadgeComponent',{staticClass:"badge-list",attrs:{"text":_vm.text,"badgeClass":_vm.badgeClass}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }